import { createSlice } from '@reduxjs/toolkit';
import { closeConfirm, showConfirm } from '../confirmSlice';
import { setEditMessage } from '../localizationSlice';

const INITITAL_STATE = {
  content: null,
  options: {},
  callback: null
};

const modalSlice = createSlice({
  name: 'modal',
  initialState: INITITAL_STATE,
  reducers: {
    open: (state, action) => {
      if (!action.payload.content) return;

      state.content = action.payload.content;
      if (action.payload.options) state.options = action.payload.options;
      if (action.payload.callback) state.callback = action.payload.callback;
    },
    close: (state) => {
      state.content = INITITAL_STATE.content;
      state.options = INITITAL_STATE.options;
      state.callback = INITITAL_STATE.callback;
    },
    setOptions: (state, action) => {
      state.options = Object.assign(state.options, action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      // on showConfirm, stop modal from preventing focus leaving from modal
    .addCase(showConfirm, (state) => {
      if (state.content) {
        state.options = Object.assign({}, state.options, { enforceFocus: false });
      }
    })
    .addCase(closeConfirm, (state) => {
      if (state.content) {
        state.options = Object.assign({}, state.options, { enforceFocus: true });
      }
    })
    // on setEditMessage, stop modal from preventing focus leaving from modal when editing localizations
    .addCase(setEditMessage, (state, action) => {
      if (!state.content) return;
      state.options = Object.assign({}, state.options, { enforceFocus: !action.payload?.id });
    })
  }
});

export default modalSlice.reducer;
export const { open, close, setOptions } = modalSlice.actions;
